import { Link } from 'react-router-dom';
import { categoryLabel, useMapSymbology } from '@/features/common/useMapSymbology';
import { useLanguage } from '@/i18n/LanguageContext';
import { publicHome } from '@/i18n/dictionaries/publicHome';
import { useTranslation } from '@/i18n/useTranslation';
import '@/features/publicsite/map/map-legend.css';

/** How many swatches the home-page strip shows before it stops being a strip. */
const HOME_LEGEND_LIMIT = 4;

/**
 * The map teaser and its legend.
 *
 * The legend was a third copy of the map's categories, with its own colours and its own labels.
 * It reads the same nomenclature as /harta now, so the two cannot show different legends for the
 * same data — which they already did.
 */
export function HomeMapTeaser() {
  const { t } = useTranslation(publicHome);
  const { language } = useLanguage();
  const mapCategories = useMapSymbology();

  return (
    <section className="section home-section--white">
      <div className="container map-grid">
        <div>
          <span className="eyebrow">{t('mapEyebrow')}</span>
          <h2 className="map-teaser__heading">{t('mapHeading')}</h2>
          <p className="map-teaser__lead">{t('mapLead')}</p>
          <ul className="map-legend">
            {mapCategories.slice(0, HOME_LEGEND_LIMIT).map((category) => (
              <li key={category.code}>
                <span className="map-legend__dot" style={{ background: category.color }} />
                {categoryLabel(category, language)}
              </li>
            ))}
          </ul>
          <div className="map-teaser__actions">
            <Link className="btn btn--primary btn--md" to="/harta">
              {t('mapOpenFull')}
            </Link>
            <Link className="btn btn--ghost btn--md" to="/consilieri">
              {t('mapByDistrict')}
            </Link>
          </div>
        </div>
        <div className="map-card map-card--teaser">
          {/* Raion outline: geoBoundaries gbOpen MDA ADM1 (CC BY 4.0), rendered to a static SVG. */}
          <div className="map-teaser__frame">
            <img src="/img/moldova-map.svg" alt="" aria-hidden="true" />
            <Link className="btn btn--primary btn--md map-teaser__cta" to="/harta">
              {t('mapOpenInteractive')}
            </Link>
          </div>
          <p className="map-teaser__caption">{t('mapCaption')}</p>
        </div>
      </div>
    </section>
  );
}
